const $inject = ['$scope', 'moment'];

const lbTripOptionsHotelFormCtrl = function ($scope, moment) {
  let vm = this;

  const apiDateFormat = 'YYYY-MM-DD[T]HH:mm:ss';
  const displayDateFormat = 'ddd Do MMM, YYYY';

  $scope.$watch('vm.searches', validateSearches, true);

  function validateSearches(searches) {
    _.forEach(searches, (search, searchIndex) => {
      let dateFromMoment = moment(search.hotel.dateFrom, displayDateFormat);
      let dateToMoment = moment(search.hotel.dateTo, displayDateFormat);
      let minDateFromMoment = moment(search.hotel.minDateFrom, displayDateFormat);

      if (dateFromMoment.isBefore(minDateFromMoment)) {
        search.hotel.dateFrom = search.hotel.minDateFrom;
      }

      if (dateToMoment.isBefore(dateFromMoment)) {
        search.hotel.dateTo = moment(search.hotel.dateFrom, displayDateFormat).add(1, 'days').format(displayDateFormat);
      }
    });
  }
};

lbTripOptionsHotelFormCtrl.$inject = $inject;

export default lbTripOptionsHotelFormCtrl;



// WEBPACK FOOTER //
// ./src/components/lbTripOptionsModal/lbTripOptionsHotelFormCtrl.js